import API from "..";

export const deleteChannel = async (id: string) => API.delete<any>(`/channel/${id}`);